/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithTypeItemRequestBuilder, WithTypeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type ValidateRequestBuilder, ValidateRequestBuilderRequestsMetadata } from './validate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/integrations/templates
 */
export interface TemplatesRequestBuilder extends BaseRequestBuilder<TemplatesRequestBuilder> {
    /**
     * The validate property
     */
    get validate(): ValidateRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.integrations.templates.item collection
     * @param type Route parameter: the category of provider to list.
     * @returns {WithTypeItemRequestBuilder}
     */
     byType(type: string) : WithTypeItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const TemplatesRequestBuilderUriTemplate = "{+baseurl}/api/integrations/templates";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TemplatesRequestBuilderNavigationMetadata: Record<Exclude<keyof TemplatesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byType: {
        requestsMetadata: WithTypeItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["type"],
    },
    validate: {
        requestsMetadata: ValidateRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
